/**
 * @module FE-CU13_戸締り確認画面コンポーネント
 */
import ListPanel from '@/components/listPanel/ListPanel.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

export default {
  name: 'LockConfirmation',
  components: {
    ListPanel,
    PCFooter,
  },
  props: {
    displayAreaTitle: {
      type: Object,
      default: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      required: false,
    },
    displayAreaList: {
      type: Array,
      required: false,
    },
    areaType: {
      type: Number,
      default: 1,
      required: false,
    },
    securityAreaList: {
      type: Array,
      required: false,
    },
    notificationImage: {
      type: String,
      required: false,
    },
    notificationTitle: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      typeLock: 1, //いずれグローバルな定数化
      typeAlert: 2,
    };
  },
};
